// Billing.js
// Purpose: Displays and manages billing information for the user, including current plan details and billing history.
// Logic: Uses React hooks and APIs to fetch, display, and update billing data, and manages related modals for billing actions.

/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useEffect, useRef, useState } from "react";
import { Modal } from "flowbite-react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import useCommonFunctions from "../hooks/common-functions";
import useCommonApi from "../hooks/common-apis";
import { clog, getPlanDetails } from "../lib/utils";
import Cookies from "js-cookie";
import ThreeDotsLoader from "../components/ThreeDotsLoader";
import SuccessModal from "../components/SuccessModal";
import FailureModal from "../components/FailureModal";
import UpgradeModal from "../components/UpgradeModal";

function Billing() {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState();
  const [openModalAddDetail, setOpenModalAddDetail] = useState();
  const [billingData, setbillingData] = useState({});
  const [billingLoading, setBillingLoading] = useState(true);
  const [openModalSorry, setOpenModalSorry] = useState(undefined);
  const [openModalOtp, setOpenModalOtp] = useState(undefined);
  const [openSuccessModal, setopenSuccessModal] = useState(undefined);
  const [openFailureModal, setopenFailureModal] = useState(undefined);
  const [successFailureMessage, setsuccessFailureMessage] = useState("");
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);

  const removeModal = () => {
    setopenSuccessModal(undefined);
    setopenFailureModal(undefined);
  };
  const [otp, setOtp] = useState(new Array(5).fill(""));
  const otpRefs = useRef(Array.from({ length: 5 }, () => null));
  const documentBodyRef = useRef(null);
  const formatDateTime = (dateTimeString) => {
    return moment(dateTimeString)?.format("D MMMM, YYYY | h:mm A");
  };
  const setExpirationCookie = (expirationDate) => {
    Cookies.set("expirationDate", expirationDate, {
      expires: new Date(expirationDate),
    });
  };
  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false;
    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);
    const nextIndex = index + 1;
    if (nextIndex < otpRefs.current.length) {
      otpRefs.current[nextIndex].focus();
    }
  };

  const [cancelSubscriptionQuestions, setcancelSubscriptionQuestions] =
    useState([
      {
        id: 1,
        question: "Going with a different provider",
        checked: false,
      },
      {
        id: 2,
        question: "Don’t have enough time to use Vison.ai",
        checked: false,
      },
      {
        id: 3,
        question: "Didn’t meet our expectations",
        checked: false,
      },
      {
        id: 4,
        question: "No Longer needed",
        checked: false,
      },
      {
        id: 5,
        question: "Missing Features",
        checked: false,
      },
      {
        id: 6,
        question: "Technical Issues",
        checked: false,
      },
    ]);
  const [cancel_remark, setcancel_remark] = useState("");
  const [count, setCount] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  const [cancellingRequest, setcancellingRequest] = useState(false);
  const [lastPayment, setLastPayment] = useState(0);

  const callOtpFn = async () => {
    try {
      let response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/user/subscription/cancel_request`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: {},
      });
      console.log(response, "response");
      // if (!response.data.error) {
      //   setsuccessFailureMessage(response.data.message);
      //   setopenSuccessModal("dismissible");
      // } else {
      //   setsuccessFailureMessage(response.data.message);
      //   setopenFailureModal("dismissible");
      // }
    } catch (error) {
      if (error.response.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
      console.log(error);
    }
  };
  const startCountdown = () => {
    setCount(60);
    setIsCounting(true);
    callOtpFn();
  };

  // LEGACY: Old state for /bal_credits API (kept for easy reversion)
  // const [creditsData, setCreditsData] = useState({
  //   limits: { credits: 0, emailAccounts: 0 },
  //   remaining: { credits: 0, emailAccounts: 0 },
  // });

  const formatDate = (dateString) => {
    return moment(dateString, "YYYY-MM-DD HH:mm:ss").format("DD MMMM, YYYY");
  };

  // clog(billingData, "billingData");
  const getBillingDetailsFn = async () => {
    setBillingLoading(true);
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/user/billing_details`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
      });
      let data = response.data || {};
      data.credit_limit = data.credit_limit || 100; // Default to 100 if undefined
      data.limits = data.limits || 100; // Default to 100 if undefined
      //if subscription_type == free then set the subscription_type to Lead Watcher Plan (Free Forever)
      if (data?.subscription?.subscription_type == "free") {
        data.subscription.subscription_type = "Lead Watcher (Free Forever)";
      } else if (data?.subscription?.subscription_type == "usage_based") {
        data.subscription.subscription_type = "Pay-as-you-go";
      }
      if (data?.subscription_type == "subscription_type") {
        data.subscription.subscription_type = "Pay-as-you-go";
      }
      setbillingData(data || {});
      setLastPayment([...data?.payment].sort(
        (a, b) => new Date(b.taxn_date) - new Date(a.taxn_date)
      )[0]?.amount || 0);
    } catch (error) {
      clog("error", error);
    } finally {
      setBillingLoading(false);
    }
  };

  // LEGACY: Old function for /bal_credits API (kept for easy reversion)
  // To revert: Uncomment this function, uncomment creditsData state above,
  // uncomment getCreditsDetailsFn() call in useEffect, and use creditsData instead of billingData in JSX
  // const getCreditsDetailsFn = async () => {
  //   try {
  //     const response = await axios({
  //       url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/user/bal_credit`,
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //         jwt_token: localStorage.getItem("login_token"),
  //       },
  //     });
  //     // {
  //     //   "error": false,
  //     //   "limits": {
  //     //     "credits": 5300,
  //     //     "emailAccounts": 10
  //     //   },
  //     //   "remaining": {
  //     //       "credits": 5228,
  //     //       "emailAccounts": 10
  //     //   }
  //     // }
  //     let data = response.data || {};
  //     setCreditsData(data || {});
  //   } catch (error) {
  //     clog("error", error);
  //   }
  // };

  const getDateTrial = (subscription) => {
    if (
      subscription &&
      subscription?.subscription_type == "Lead Watcher (Free Forever)"
    ) {
      if (subscription?.expire_date) {
        const expireDate = moment(subscription.expire_date);
        const currentDate = moment();

        if (currentDate.isAfter(expireDate)) {
          return "NA";
        }

        return expireDate.format("D MMMM, YYYY");
      } else {
        return "NA";
      }
    } else {
      return "NA";
    }
  };

  const cancelSubscriptionFn = async (subscription) => {
    setcancellingRequest(true);
    let checked_questions = cancelSubscriptionQuestions.filter(
      (question) => question.checked == true
    );
    let checkedQuestionsObj = {};
    checked_questions.forEach((question) => {
      checkedQuestionsObj[question.question] = true;
    });

    let currency = subscription?.currency?.toUpperCase() || "";
    let gatway = "";
    if (currency == "USD") {
      gatway = "stripe";
    } else if (currency == "INR") {
      gatway = "razorpay";
    } else {
      gatway = "";
    }
    try {
      let response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/user/subscription/cancel`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: {
          subscription_id: subscription?.subscription_id,
          verifytxt: otp.join(""), //OTP
          cancel_remark: cancel_remark,
          cancel_question: checkedQuestionsObj,
          gatway: gatway, //razorpay or stripe
        },
      });
      setcancellingRequest(false);
      console.log(response, "response");
      if (!response.data.error) {
        let details = response.data;
        // localStorage.setItem("subscription_upgrade_details", JSON.stringify(details));
        setOpenModalOtp(undefined);
        setsuccessFailureMessage(response.data.message);
        setopenSuccessModal("dismissible");
        setTimeout(() => {
          setOpenModal(undefined);
        }, 2000);
        setExpirationCookie(details?.subscription?.expire_date);
        let login_data = JSON.parse(localStorage.getItem("login_data"));
        login_data.resp_user.subscription_expire_date =
          details?.subscription?.expire_date;
        login_data.resp_user.subscription_status =
          details?.subscription?.status;
        // setloginData(login_data);
        localStorage.setItem("login_data", JSON.stringify(login_data));
        setbillingData((prev) => ({
          ...prev,
          subscription: {
            ...prev.subscription,
            expire_date: details?.subscription?.expire_date,
            status: details?.subscription?.status,
          },
        }));
      } else {
        setsuccessFailureMessage(response.data.message);
        setopenFailureModal("dismissible");
      }
    } catch (error) {
      setcancellingRequest(false);
      if (error.response.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
      console.log(error);
    }
  };

  useEffect(() => {
    // LEGACY: Uncomment this line to use old /bal_credits API
    // getCreditsDetailsFn();
    getBillingDetailsFn();

  }, []);

  useEffect(() => {
    let interval;

    if (isCounting && count > 0) {
      interval = setInterval(() => {
        setCount(count - 1);
      }, 1000);
    }

    if (count === 0 || !isCounting || cancellingRequest) {
      clearInterval(interval);
      setIsCounting(false);
    }

    return () => clearInterval(interval);
  }, [count, isCounting, cancellingRequest]);
  return (
    <>
      <div className="px-2 flex items-center">
        <div>
          <h6 className="font-bold text-[24px]">Billing</h6>
          <p className="font-semibold text-[18px]">
            You Are On{" "}
            {billingLoading ? (
              <span className="inline-block h-5 w-64 bg-gray-300 rounded skeleton-wave align-middle"></span>
            ) : billingData?.plan_id === 8 ? (
              <span>{billingData?.subscription_type.replace(/_/g, "-")} Plan</span>
            ) : (
              <>
                {billingData?.plan?.subscription_name}{" "}
                {billingData?.subscription?.subscription_type} Plan
              </>
            )}
          </p>
        </div>
        {getPlanDetails() != 6 && (
          <div className="ms-auto">
            {billingData?.subscription?.status == 0 &&
              billingData?.subscription?.expire_date ? (
              <div className="font-semibold text-[18px]">
                Your subscription will expire on{" "}
                {moment(billingData?.subscription?.expire_date)?.format(
                  "D MMMM, YYYY | h:mm A"
                )}
              </div>
            ) : (
              <>
                {getDateTrial(billingData?.subscription) !== "NA" ? (
                  <></>
                ) : (
                  <button
                    type="button"
                    className="px-[20px] btn-default-cancel"
                    onClick={() => {
                      setOpenModalSorry("dismissible");
                      setcancelSubscriptionQuestions((prev) =>
                        prev.map((question) => {
                          return { ...question, checked: false };
                        })
                      );
                      setcancel_remark("");
                      setcancellingRequest(false);
                    }}
                  >
                    Cancel Subscription
                  </button>
                )}
              </>
            )}
          </div>
        )}
      </div>
      {
        // getPlanDetails() != 6 &&
        <div className="h-full">
          <div className="w-full h-full py-4">
            {billingLoading ? (
              <div className="flex flex-wrap">
                {[...Array(3)].map((_, index) => (
                  <div
                    key={index}
                    className="w-full md:w-1/3 p-2 flex justify-center"
                  >
                    <div className="w-full p-[10px] rounded-[15px] flex bg-[#FAFBFC] border border-[#E9EBF0]">
                      <div className="me-4">
                        <div className="flex items-center justify-center w-[50px] h-[44px] bg-gray-300 rounded-tl-[15px] rounded-br-[15px] rounded-tr-[6px] rounded-bl-[6px] skeleton-wave"></div>
                      </div>
                      <div className="flex-1">
                        <div className="h-4 w-24 bg-gray-300 rounded skeleton-wave mb-2"></div>
                        <div className="h-6 w-40 bg-gray-300 rounded skeleton-wave"></div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="flex flex-wrap">
                <div className="w-full md:w-1/3 p-2 flex justify-center">
                  <div className="w-full p-[10px] rounded-[15px] flex bg-[#FAFBFC] border border-[#E9EBF0] ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 cursor-pointer hover:shadow-lg hover:shadow-[#E9F2FF] hover:border-[#097BA9] hover:text-[#097BA9]">
                    <div className="me-4">
                      <div className="flex items-center justify-center w-[50px] h-[44px] bg-[#E9F2FF] rounded-tl-[15px] rounded-br-[15px] rounded-tr-[6px] rounded-bl-[6px]">
                        <svg className="icon">
                          <use href="#icon_cycle"></use>
                        </svg>
                      </div>
                    </div>
                    <div>
                      <p className="font-bold">CYCLE</p>
                      <p className="font-semibold text-[24px] pt-2">
                        {billingData?.plan?.subscription_name}{" "}
                        {billingData?.plan_id === 8
                          ? billingData?.subscription_type.replace(/_/g, "-")
                          : billingData?.subscription?.subscription_type === "Lead Watcher (Free Forever)"
                            ? "Monthly"
                            : billingData?.subscription?.subscription_type
                        }
                      </p>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/3 p-2 flex justify-center">
                  <div className="w-full p-[10px] rounded-[15px] flex bg-[#FAFBFC] border border-[#E9EBF0] ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 cursor-pointer hover:shadow-lg hover:shadow-[#E9F2FF] hover:border-[#097BA9] hover:text-[#097BA9]">
                    <div className="me-4">
                      <div className="flex items-center justify-center w-[50px] h-[44px] bg-[#E9F2FF] rounded-tl-[15px] rounded-br-[15px] rounded-tr-[6px] rounded-bl-[6px]">
                        <svg className="icon">
                          <use href="#icon_bill"></use>
                        </svg>
                      </div>
                    </div>
                    <div>

                      <p className="font-bold">
                        {billingData?.plan_id === 8
                          ? (
                            <>
                              Total Credit
                              <p className="font-semibold text-[24px] pt-2">{billingData?.remaining}</p>
                            </>
                          )
                          : (
                            <>
                              NEXT BILLING PERIOD
                              <p className="font-semibold text-[24px] pt-2">
                                {billingData?.subscription?.expire_date
                                  ? formatDate(billingData?.subscription?.expire_date)
                                  : ""
                                }
                              </p>
                            </>
                          )
                        }
                      </p>
                    </div>
                  </div>
                </div>
                {
                  // dont show if subscription_type == usage_based
                  billingData?.subscription_type !== "usage_based" &&
                  <div className="w-full md:w-1/3 p-2 flex justify-center">
                    <div className="w-full p-[10px] rounded-[15px] flex bg-[#FAFBFC] border border-[#E9EBF0] ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 cursor-pointer hover:shadow-lg hover:shadow-[#E9F2FF] hover:border-[#097BA9] hover:text-[#097BA9]">
                      <div className="me-4">
                        <div className="flex items-center justify-center w-[50px] h-[44px] bg-[#E9F2FF] rounded-tl-[15px] rounded-br-[15px] rounded-tr-[6px] rounded-bl-[6px]">
                          <svg className="icon">
                            <use href="#icon_calculator"></use>
                          </svg>
                        </div>
                      </div>
                      <div>
                        <p className="font-bold">Last Payment</p>
                        <p className="font-semibold text-[24px] pt-2">
                          <span>

                            ${lastPayment} USD
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>}
              </div>
            )}
          </div>
        </div>
      }
      <div className="w-full pb-4">
        <p className="font-semibold px-2 text-[20px] pb-2">
          Consumption Till {formatDate(new Date())}
        </p>
        <div className="flex flex-wrap">
          <div className="w-full md:w-1/2 p-2">
            <div className="w-full p-[10px] rounded-[15px] flex bg-[#FAFBFC] border border-[#E9EBF0]">
              <div className="w-full border p-[10px] rounded-[12px] bg-[#fff] text-center  font-semibold">
                {/* NEW: Using limits and remaining from /billing_details API */}
                {billingData?.subscription_type == "usage_based" ? <>
                  {billingData?.used_credits} leads identified • Estimated cost: ${billingData?.total_credit_cost}
                </> : billingData?.limits !== undefined &&
                  billingData?.remaining !== undefined ? (
                  <>
                    {billingData?.remaining} credits remaining out of{" "}
                    {billingData?.limits} credits
                  </>
                ) : (
                  <>&nbsp;</>
                )}

                {/* LEGACY: Old logic using /bal_credits API (kept for easy reversion) */}
                {/* To revert: Comment out the NEW section above and uncomment below */}
                {/* {creditsData?.limits ? (
                  <>
                    {creditsData?.limits?.credits -
                      creditsData?.remaining?.credits}{" "}
                    credits used out of {creditsData?.limits?.credits} credits
                  </>
                ) : (
                  <>&nbsp;</>
                )} */}
              </div>
            </div>
          </div>
          {/* <div className="w-full md:w-1/2 p-2">
            <div className="w-full p-[10px] rounded-[15px] flex bg-[#FAFBFC] border border-[#E9EBF0]">
              <div className="w-full border p-[10px] rounded-[12px] bg-[#fff] text-center  font-semibold">
                {
                  billingData?.usersetting?.find(
                    (item) => item?.key_name == "template_word"
                  )?.current_value
                }{" "}
                Words Generated
              </div>
            </div>
          </div> */}
          {/* upgrade button */}
          <div className="w-full md:w-1/2 p-2">
            <div className="w-full h-full flex items-center ">
              {getPlanDetails() == 6 && (
                <button
                  className="py-2 px-6 rounded-[20px] font-[600] text-[18px] bg-gradient-to-r from-[#5E78F4] to-[#F14CE2] text-white  hover:border-white hover:scale-105 hover:bg-gradient-to-tr "
                  onClick={() => {
                    setIsUpgradeModalOpen(true);
                  }}
                >
                  Upgrade
                  <svg className="icon text-[22px] ms-2">
                    <use href="#icon_arrow"></use>
                  </svg>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="px-2">
        <h6 className="font-bold text-[24px]">Billing Details</h6>
        <div className="flex">
          <p className="font-semibold text-[18px]">
            Each Time You Are Billed, An Email WIll Be Sent To:{" "}
            {JSON.parse(localStorage.getItem("login_data")).resp_user?.email}
          </p>
        </div>
      </div>

      <div className="tbl-scroller px-2 py-4">
        {billingLoading ? (
          <table className="table">
            <thead className="bg-[red]">
              <tr>
                <th>Invoice Number</th>
                <th>Invoice Date</th>
                <th>Paid Date</th>
                <th>Amount</th>
                <th>Description</th>
                <th>Download</th>
              </tr>
            </thead>
            <tbody className="tbody-gap">
              <td colSpan="7"></td>
            </tbody>
            <tbody>
              {[...Array(4)].map((_, index) => (
                <tr key={index}>
                  <td style={{ borderRadius: "25px" }}>
                    <div className="h-4 w-32 bg-gray-300 rounded skeleton-wave"></div>
                  </td>
                  <td>
                    <div className="h-4 w-28 bg-gray-300 rounded skeleton-wave"></div>
                  </td>
                  <td>
                    <div className="h-4 w-28 bg-gray-300 rounded skeleton-wave"></div>
                  </td>
                  <td>
                    <div className="h-4 w-20 bg-gray-300 rounded skeleton-wave"></div>
                  </td>
                  <td>
                    <div className="h-4 w-40 bg-gray-300 rounded skeleton-wave"></div>
                  </td>
                  <td style={{ borderRadius: "25px" }}>
                    <div className="h-8 w-8 rounded-full bg-gray-300 skeleton-wave mx-auto"></div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <table className="table">
            <thead className="bg-[red]">
              <tr>
                <th>Invoice Number</th>
                <th>Invoice Date</th>
                <th>Paid Date</th>
                <th>Amount</th>
                <th>Description</th>
                <th>Download</th>
              </tr>
            </thead>
            <tbody className="tbody-gap">
              <td colSpan="7"></td>
            </tbody>
            <tbody>
              {billingData?.payment?.map((payment, payment_index) => (
                <tr key={payment_index}>
                  <td style={{ borderRadius: "25px" }}>
                    {payment?.invoice_number}
                  </td>
                  <td>{formatDate(payment?.taxn_date)}</td>
                  <td>{formatDate(payment?.taxn_date)}</td>
                  <td>
                    <span>
                      {billingData?.subscription?.currency?.toUpperCase() ===
                        "USD"
                        ? "$"
                        : "₹"}
                    </span>
                    {payment?.amount}
                  </td>
                  <td>{payment?.subscription_type == "usage_based" ? "Pay-as-you-go" : payment?.subscription_type || ""}</td>
                  <td style={{ borderRadius: "25px" }}>
                    <button
                      type="button"
                      className="hover:text-[#9D3784]"
                      onClick={() => {
                        window.open(payment?.invoice_pdf, "_blank");
                      }}
                    >
                      <svg className="icon text-[22px]">
                        <use href="#icon_download"></use>
                      </svg>
                    </button>
                  </td>
                </tr>
              ))}
              {billingData?.payment?.length === 0 && (
                <tr>
                  <td
                    colSpan="7"
                    className="text-center"
                    style={{ borderRadius: "25px" }}
                  >
                    No Billing Details
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      {/* Modal Add Card */}
      <Modal
        dismissible
        show={openModal === "dismissible"}
        size="lg"
        onClose={() => setOpenModal(undefined)}
      >
        <Modal.Header className="capitalize py-2">
          <h6 className="font-bold text-[24px]">Add New Card</h6>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <form class="w-full">
            <div className="pt-3">
              <label class="block mb-2 font-[400] text-[18px]" for="first-name">
                Card Number
              </label>
              <input
                type="number"
                className="w-full border border-[#E9EBF0] rounded-full mb-[20px] font-[400] text-[16px] bg-[#FAFBFC]"
                placeholder="Enter card number"
              />
            </div>
            <div class="flex flex-wrap -mx-6">
              <div class="w-full md:w-1/2 px-6 md:mb-0">
                <label
                  class="block mb-2 font-[400] text-[18px]"
                  for="first-name"
                >
                  Expiry Date
                </label>
                <input
                  type="text"
                  className="w-full border border-[#E9EBF0] rounded-full mb-[20px] font-[400] text-[16px] bg-[#FAFBFC]"
                  placeholder="MM/YY"
                />
              </div>
              <div class="w-full md:w-1/2 px-6">
                <label
                  class="block mb-2 font-[400] text-[18px]"
                  for="first-name"
                >
                  CVV
                </label>
                <input
                  type="number"
                  className="w-full border border-[#E9EBF0] rounded-full mb-[20px] font-[400] text-[16px] bg-[#FAFBFC]"
                  placeholder="Enter cvv"
                />
              </div>
            </div>
            <div className="pb-3">
              <label class="block mb-2 font-[400] text-[18px]" for="first-name">
                Card Holder Name
              </label>
              <input
                type="text"
                className="w-full border border-[#E9EBF0] rounded-full mb-[20px] font-[400] text-[16px] bg-[#FAFBFC]"
                placeholder="Enter card holder name"
              />
            </div>
          </form>
          <div className="flex">
            <button
              type="buttonn"
              className="w-full justify-center py-2 px-[20px] rounded-[20px] font-semibold bg-gradient-to-r from-[#1A71A7] to-[#9D3784] text-white  hover:from-[#9D3784] hover:to-[#1A71A7]"
              onClick={() => setOpenModal(undefined)}
            >
              Add Card
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Modal Add Detail */}
      <Modal
        dismissible
        show={openModalAddDetail === "dismissible"}
        size="lg"
        onClose={() => setOpenModalAddDetail(undefined)}
      >
        <Modal.Header className="capitalize py-2">
          <h6 className="font-bold text-[24px]">Add Details</h6>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <form class="w-full">
            <div className="pt-3">
              <label class="block mb-2 font-[400] text-[18px]" for="first-name">
                Company Name
              </label>
              <input
                type="text"
                className="w-full border border-[#E9EBF0] rounded-full mb-[20px] font-[400] text-[16px] bg-[#FAFBFC]"
                placeholder="Enter company name"
              />
            </div>
            <div class="flex flex-wrap -mx-6">
              <div class="w-full md:w-1/2 px-6 md:mb-0">
                <label
                  class="block mb-2 font-[400] text-[18px]"
                  for="first-name"
                >
                  First Name
                </label>
                <input
                  type="text"
                  className="w-full border border-[#E9EBF0] rounded-full mb-[20px] font-[400] text-[16px] bg-[#FAFBFC]"
                  placeholder="Enter first name"
                />
              </div>
              <div class="w-full md:w-1/2 px-6">
                <label
                  class="block mb-2 font-[400] text-[18px]"
                  for="first-name"
                >
                  Last Name
                </label>
                <input
                  type="text"
                  className="w-full border border-[#E9EBF0] rounded-full mb-[20px] font-[400] text-[16px] bg-[#FAFBFC]"
                  placeholder="Enter last name"
                />
              </div>
            </div>
            <div className="">
              <label class="block mb-2 font-[400] text-[18px]" for="first-name">
                VAT / GST
              </label>
              <input
                type="text"
                className="w-full border border-[#E9EBF0] rounded-full mb-[20px] font-[400] text-[16px] bg-[#FAFBFC]"
                placeholder="Enter VAT / GST"
              />
            </div>
            <div className="pb-3">
              <label class="block mb-2 font-[400] text-[18px]" for="first-name">
                Phone
              </label>
              <input
                type="tel"
                className="w-full border border-[#E9EBF0] rounded-full mb-[20px] font-[400] text-[16px] bg-[#FAFBFC]"
                placeholder="Enter phone"
              />
            </div>
          </form>
          <div className="flex">
            <button
              type="buttonn"
              className="w-full justify-center py-2 px-[20px] rounded-[20px] font-semibold bg-gradient-to-r from-[#1A71A7] to-[#9D3784] text-white  hover:from-[#9D3784] hover:to-[#1A71A7]"
              onClick={() => setOpenModalAddDetail(undefined)}
            >
              Add Details
            </button>
          </div>
        </Modal.Body>
      </Modal>
      {/* Modal We Are Sorry */}
      <Modal
        root={documentBodyRef.current}
        dismissible
        show={openModalSorry === "dismissible"}
        size="5xl"
        onClose={() => setOpenModalSorry(undefined)}
      >
        <Modal.Header className="capitalize py-2 border-0"></Modal.Header>
        <Modal.Body className="p-0">
          <div className="w-full">
            <div className="w-full px-[40px] py-4">
              <div className="pb-4 flex items-center">
                <div>
                  <h6 className="font-bold text-[24px]">
                    We Are Sorry To See You Go
                  </h6>
                  <p className="font-[400] text-[16px]">
                    Can you help us understand why?
                  </p>
                </div>
                <svg className="icon text-[38px] ms-8">
                  <use href="#icon_sad"></use>
                </svg>
              </div>

              <div class="flex flex-wrap -mx-6">
                {cancelSubscriptionQuestions?.map(
                  (question, question_index) => (
                    <div
                      class="w-full md:w-1/2 px-6 mb-6 md:mb-0"
                      key={question_index}
                      onClick={() => {
                        setcancelSubscriptionQuestions((prev) =>
                          prev.map((item, index) => {
                            if (item.id == question.id) {
                              return { ...item, checked: !item.checked };
                            }
                            return item;
                          })
                        );
                      }}
                    >
                      <div className="flex items-center gap-1 w-full mb-[20px] text-start p-[10px] rounded-[15px] bg-[#FAFBFC] border border-[#E9EBF0] ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 cursor-pointer hover:shadow-lg hover:shadow-[#E9F2FF] hover:border-[#097BA9] hover:text-[#097BA9]">
                        <div>
                          <input
                            id="checkboxOne"
                            type="checkbox"
                            value=""
                            checked={question.checked}
                            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                          />
                        </div>
                        <div className="pt-1">{question.question}</div>
                      </div>
                    </div>
                  )
                )}
              </div>

              <div className="pb-4">
                <label for="message" class="block mb-2 font-[400] text-[16px]">
                  <h6 className="font-bold text-[24px]">
                    Anything we could have done better?
                  </h6>
                  You honest input is the best way we can improve our product
                </label>
                <textarea
                  id="message"
                  rows="4"
                  value={cancel_remark}
                  onChange={(e) => setcancel_remark(e.target.value)}
                  class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-[#E9EBF0] focus:ring-[#097BA9] focus:border-[#097BA9] dark:bg-gray-700 dark:border-[#097BA9] dark:placeholder-gray-400 dark:text-white dark:focus:ring-[#097BA9] dark:focus:border-[#097BA9]"
                ></textarea>
              </div>

              <div className="flex items-center py-4">
                <div>
                  <button
                    type="button"
                    className="flex items-center py-1 px-8 rounded-[20px] font-semibold border border-[black] opacity-[0.4]"
                    onClick={() => {
                      setOpenModalSorry(undefined);
                      startCountdown();
                      setOtp(new Array(5).fill(""));
                      setOpenModalOtp("dismissible");
                    }}
                  >
                    No, Continue
                  </button>
                </div>

                <div className="ms-6">
                  <button
                    type="button"
                    className="flex items-center py-2 px-10 rounded-[20px] font-semibold border border-[black]"
                    onClick={() => {
                      setOpenModal(undefined);
                      setOpenModalOtp(undefined);
                      setOpenModalSorry(undefined);
                    }}
                  >
                    Keep Subscription
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        dismissible
        show={openModal === "dismissible"}
        size="xl"
        onClose={() => setOpenModal(undefined)}
      >
        <Modal.Body className="p-0">
          <div className="w-full">
            <div className="w-full px-[40px] py-4">
              <div className="flex justify-center py-6">
                <svg className="icon text-[50px]">
                  <use href="#icon_cancel"></use>
                </svg>
              </div>
              <p className="font-[600] text-[24px] text-center pb-6">
                Your Subscription Has Been Successfully Cancelled
              </p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        root={documentBodyRef.current}
        show={openModalOtp === "dismissible"}
        size="xl"
        onClose={() => setOpenModalOtp(undefined)}
      >
        <Modal.Header className="capitalize pb-2 border-0"></Modal.Header>
        <Modal.Body className="p-0">
          <div className="w-full">
            <div className="w-full px-[40px] py-4">
              <div className="pb-5">
                <h6 className="font-bold text-[24px] text-center pb-5">
                  Cancel Subscription
                </h6>
                <p className="font-[400] text-[20px] text-center">
                  Please enter 5 digit Verification code sent to&nbsp;
                  {
                    JSON.parse(localStorage.getItem("login_data"))?.resp_user
                      ?.email
                  }{" "}
                </p>
              </div>
              <div className="my-3 otp-input">
                {otp.map((data, index) => {
                  return (
                    <input
                      type="text"
                      key={index}
                      value={data}
                      className="form-control otp-box focus:ring-[#9D3784] dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2"
                      required
                      maxLength="1"
                      name="otp"
                      ref={(ref) => (otpRefs.current[index] = ref)}
                      onChange={(e) => handleChange(e.target, index)}
                    />
                  );
                })}
              </div>

              <button
                type="button"
                className="w-full my-6 py-2 px-10 rounded-[25px] font-[400] text-[22px] border border-[black]"
                onClick={() => {
                  cancelSubscriptionFn(billingData?.subscription);
                }}
              >
                <div className="flex justify-between items-center">
                  <div></div>
                  <div>{cancellingRequest ? "Submitting" : "Submit"}</div>
                  <div>
                    {cancellingRequest ? <ThreeDotsLoader /> : <> {""}</>}
                  </div>
                </div>
              </button>

              <p className="text-center pb-4 font-[700] text-[20px] cursor-pointer">
                <button
                  disabled={isCounting}
                  className={`group text-transparent bg-clip-text 
                  bg-gradient-to-r ${isCounting
                      ? "from-[#B0B0B0] to-[#B0B0B0]"
                      : "from-[black] to-[black]"
                    }
                `}
                  onClick={startCountdown}
                >
                  Resend Code
                </button>{" "}
                <span className="text-[#014E82]">
                  {isCounting ? <>in {count} sec</> : ""}
                </span>
              </p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <SuccessModal
        open={openSuccessModal}
        removeModal={removeModal}
        successFailureMessage={successFailureMessage}
      />
      <FailureModal
        open={openFailureModal}
        removeModal={removeModal}
        successFailureMessage={successFailureMessage}
      />
      <UpgradeModal
        isOpen={isUpgradeModalOpen}
        setIsOpen={setIsUpgradeModalOpen}
      />
    </>
  );
}

export default Billing;
